import { Link } from "react-router-dom";
import '../../styles/member.css';
import React, { useEffect, useState } from 'react';
import HeaderFFF from '../../components/HeaderFFF'
import Header from '../../components/Header'
import Footer from "../../components/Footer";

export default function JacobLee() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1000);
      
          useEffect(() => {
              const handleResize = () => {
                  setIsMobile(window.innerWidth <= 991);
              };
      
              window.addEventListener('resize', handleResize);
              return () => window.removeEventListener('resize', handleResize);
          }, []);
      
          return(
              <>
              {isMobile ? <Header /> : <HeaderFFF />}
        <div id="team-header-container">
            <svg xmlns="http://www.w3.org/2000/svg" width="102" height="2" viewBox="0 0 102 2" fill="none">
                <path d="M101 1H1" stroke="#BF9874" stroke-width="2" stroke-linecap="round"/>
            </svg>
            <h2>Jacob H. C. Lee</h2>
            <svg xmlns="http://www.w3.org/2000/svg" width="102" height="2" viewBox="0 0 102 2" fill="none">
                <path d="M101 1H1" stroke="#BF9874" stroke-width="2" stroke-linecap="round"/>
            </svg>
        </div>
        <div className="member-container">
            <div className="member-box">
                <div className="member-photo">
                    <img src="https://t4.ftcdn.net/jpg/00/65/77/27/360_F_65772719_A1UV5kLi5nCEWI0BNLLiFaBPEkUbv5Fv.jpg" alt="/"></img>
                    <div>
                        <p>Partner</p><p>(905) 370-1093</p><a href="mailto:jlee@clvlaw.ca">jlee@clvlaw.ca</a></div>
                </div>
                <div className="member-info">
                    <p>Jacob handles a broad range of corporate and commercial matters for corporations, partnerships and individuals. He helps clients at the start-up stage select the appropriate vehicle for the conduct of their businesses, which may be a business corporation, not-for-profit corporation, general partnership, limited partnership, limited liability company, limited liability partnership or business trust, and negotiate the related shareholders agreements, partnership agreements or trust agreements.
                    
                    <br/><br/>Jacob also assists clients with developing programs for protection of their ideas, technology, intellectual property and business identity, negotiating leases, drafting of standard agreements, development of human resources procedures, general legal advice, strategic planning, and negotiating and structuring business transactions, mergers and acquisitions, divestitures and reorganizations.
<br/><br/>
Jacob also assists clients with implementing and completing real estate transactions including acquisitions, sales and financing of various types of properties, including commercial and industrial properties and various types of residential properties such as single unit homes, townhouses, condominiums and vacation properties. He also provides mortgage enforcement services to both lenders and borrowers.
<br/><br/>
Prior to starting Corsianos Lee with George Corsianos in March 2008, Jacob practiced as an associate with the boutique firm in Vaughan after having articled at Aird & Berlis LLP in Toronto. Jacob has also worked as a foreign legal trainee for the law firm of Anderson Mori in Tokyo, Japan, a marketing intern for PixStream Inc. in Waterloo, a web designer for the University of Toronto, Faculty of Law and a design engineer for both ATI Technologies Inc. in Thornhill and Cypress Semiconductors in San Jose, California.
<br/><br/>
Jacob speaks fluent Mandarin and is conversant in French, Cantonese and Japanese.
<br/><br/>
Jacob enjoys running and triathlons. He has completed a number of marathons and triathlons of varying lengths, including The Canadian Iron 226 Triathlon in 2007.</p>
                </div>
                <div className="member-info-box">
                                        <div><h4>Practices</h4>
                                        <ul>
                                            <li><Link to="/fields-of-expertise/corporate-and-commercial-law">Corporate & Commercial</Link></li>
                                            <li><Link to="/fields-of-expertise/real-estate">Real Estate</Link></li>   
                                        </ul></div>
                                        <div><h4>Education</h4>
                                        <ul>
                                            <li>B.A.Sc. (Computer Engineering), University of Waterloo, 1997</li>
                                            <li>Joint J.D. and M.B.A., University of Toronto, 2002</li>
                                        </ul></div>
                                        <div><h4>Qualification</h4>
                                        <ul>
                                            <li>Called to the Ontario Bar in 2003 with three awards</li>
                                        </ul></div>
                                        <div><h4>Affiliations</h4>
                                        <ul>
                                            <li>Canadian Bar Association</li>
                                            <li>Ontario Bar Association</li>
                                            <li>Law Society of Ontario</li>
                                        </ul></div>
                                        <div><h4>Special Designations</h4>
                                        <ul>
                                            <li>The Osgoode Society for Canadian Legal History Prize (Top 25 Student), Bar Admission Course, 2003</li>
                                            <li>The Margaret P. Hyndman Prize (Second in Business Law), Bar Admission Course 2003</li>
                                            <li>The William Belmont Common Prize (Second in Criminal Law), Bar Admission Course 2003</li>
                                            <li>Passed 2006 CFA Level 3 Exam, Charter Pending</li>
                                            <li>Canadian Securities Course, Honours 2002</li>
                                        </ul>
                                        </div>
                                    </div>
            </div>
        </div>
            <div className="next-page-double-btn">
                <div className="next-page-btn">
                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="17" viewBox="0 0 13 17" fill="none">
                        <path d="M0.840374 9.59939L10.1851 15.9612C11.3584 16.76 12.8873 15.9263 12.9941 14.4904C13.002 14.3844 12.9831 14.2785 12.9499 14.1776L10.961 8.13557L12.9499 2.09351C12.9831 1.99261 13.002 1.8867 12.9941 1.78077C12.8886 0.364848 11.397 -0.472328 10.2228 0.285009L0.878026 6.31197C-0.276088 7.05633 -0.296349 8.82552 0.840374 9.59939Z" fill="#BF9874"/>
                    </svg>
                    <p><Link to="/our-team/george-corsianos">George Corsianos</Link></p>
                </div>
                <div className="next-page-btn">   
                    <p><Link to="/our-team/mick-vashishth">Mick Vashishth</Link></p>
                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="17" viewBox="0 0 13 17" fill="none">
                        <path d="M12.1596 6.33849L2.81487 0.29479C1.64616 -0.461075 0.12465 0.321745 0.00723972 1.67603C-0.00238562 1.78706 0.018628 1.89822 0.0551139 2.00352L2.03901 7.72912L0.055114 13.4547C0.018628 13.56 -0.00238987 13.6712 0.00725817 13.7822C0.123306 15.1176 1.60765 15.9038 2.77722 15.1872L12.122 9.46154C13.2761 8.7544 13.2963 7.07367 12.1596 6.33849Z" fill="#BF9874"/>
                    </svg>
                </div>
            </div>
    <Footer/>
    </>
  );
}